module.exports = __webpack_public_path__ + "img/product-preview-14.a37d672.png";